/** 
          
              .css_class_0 {
                  block-size: 1000px;
              bottom: 0px;
              font-family: "Netflix Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
              height: 1000px;
              inset-block-end: 0px;
              inset-block-start: 0px;
              inset-inline-end: 0px;
              inset-inline-start: 0px;
              left: 0px;
              min-block-size: 1000px;
              min-height: 1000px;
              perspective-origin: 966.5px 500px;
              position: relative;
              right: 0px;
              top: 0px;
              transform-origin: 966.5px 500px;
              z-index: 0;
              -webkit-locale: "fr-US";
              }
          
          
           * */
import React from 'react';
import './MainView.scss';
export default function MainView(props: any) {
    return (
        <div className="mainview" id={`main-view`} role={`main`} style-extractor={`0`}  >
            {props.children}
        </div>
    )
}